import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Globals, Constants, Permissions, Print } from 'utils';
import Header from './header';
import $ from 'jquery';
import { Logo } from 'assets/img';
import moment from 'moment';
import { ReportService, CollectionService } from 'services';
import { Button, Modal, DatePicker } from 'components';
import { ArrowUp, ArrowBottom, Menu as MenuIcons, MenuIcon } from 'assets/icons';
import ModalDownloadCollections from './admin/collections/modal-download';

interface MenuItem {
	name: string;
	path: string;
	submenu?: MenuItem[];
	icon?: string;
	permission?: string;
	onClick?: () => void;
	iconActive?: string;
	code: string;
	isLogout?: boolean;
}

class Menu extends React.Component<any> {

	state: any = {
		leftOpen: this.props.sidebar,
		openResponsive: false,
		items: [
			// { name: 'Inicio', path: '/admin/home', icon: MenuIcons.Menu1, iconActive: MenuIcons.Menu1 },
			{ name: 'Validación de Usuarios', path: '/admin/users', icon: MenuIcons.Menu2, iconActive: MenuIcons.Menu2, permission: Constants.MODULES.USERS },
			{ name: 'Creación de San', path: '/admin/san', icon: MenuIcons.Menu3, iconActive: MenuIcons.Menu3, permission: Constants.MODULES.SAN },
			{ name: 'Sanes Estructurados', path: '/admin/structures', icon: MenuIcons.Menu10, iconActive: MenuIcons.Menu10, permission: Constants.MODULES.STRUCTURE },
			{ name: 'Gestión de Posiciones', path: '/admin/positions', icon: MenuIcons.Menu4, iconActive: MenuIcons.Menu4, permission: Constants.MODULES.POSITIONS },
			{ name: 'Acreditaciones', path: '/admin/accreditations', icon: MenuIcons.Menu8, iconActive: MenuIcons.Menu8, permission: Constants.MODULES.ACCREDITATIONS },
			{ name: 'Gestión de Pagos', path: '/admin/payments', icon: MenuIcons.Menu5, iconActive: MenuIcons.Menu5, permission: Constants.MODULES.PAYMENTS },
			// { name: 'Chats de Soporte', path: '/admin/chats', icon: MenuIcons.Menu17, iconActive: MenuIcons.Menu17, permission: Constants.MODULES.CHATS },
			{ name: 'Intereses y Comisiones', path: '/admin/commissions', icon: MenuIcons.Menu7, iconActive: MenuIcons.Menu7, permission: Constants.MODULES.COMMISSIONS },
			{ name: 'Cobranzas', path: '/admin/collections', icon: MenuIcons.Menu12, iconActive: MenuIcons.Menu12, permission: Constants.MODULES.COLLECTIONS },
			{ name: 'Reportes', path: '/admin/reports', icon: MenuIcons.Menu6, iconActive: MenuIcons.Menu6, permission: Constants.MODULES.REPORTS, submenu: [
				{ name: 'Historial de pagos', path: '/admin/reports/payments' },
				{ name: 'Puntajes por usuario', path: '/admin/reports/points' },
				{ name: 'Reporte P2P', onClick: () => {
					this.openModalDownload();
				} },
				{ name: 'Reporte Facturación Premium', onClick: () => {
					this.openModalPremium();
				} },
				{ name: 'Reporte de cobranzas', onClick: () => {
					this.openModalCollections();
				} },
			] },
			{ name: 'Notificaciones', path: '/admin/global-notifications', icon: MenuIcons.Menu9, iconActive: MenuIcons.Menu9, permission: Constants.MODULES.NOTIFICATIONS },
			{ name: 'Recordatorios', path: '/admin/reminders', icon: MenuIcons.Menu13, iconActive: MenuIcons.Menu13, permission: Constants.MODULES.REMINDERS },
			{ name: 'Encuestas', path: '/admin/surveys', icon: MenuIcons.Menu14, iconActive: MenuIcons.Menu14, permission: Constants.MODULES.SURVEYS },
			// { name: 'Misiones', path: '/admin/missions', icon: MenuIcons.Menu15, iconActive: MenuIcons.Menu15, permission: Constants.MODULES.MISSIONS },
			{ name: 'Referidos', path: '/admin/referrals', icon: MenuIcons.Menu16, iconActive: MenuIcons.Menu16, permission: Constants.MODULES.REFERRALS },
			{ name: 'Moderadores', path: '/admin/moderators', icon: MenuIcons.Menu11, iconActive: MenuIcons.Menu11, permission: Constants.MODULES.MODERATORS },
			{ name: 'Publicidades', path: '/admin/advertisements', icon: MenuIcons.Menu18, iconActive: MenuIcons.Menu18, permission: Constants.MODULES.ADVERTISEMENTS },
		],
		modal_download: false,
		modal_download_collections: false,
		modal_premium: false,
		form: {
			since: '',
			until: ''
		},
		form_premium: {
			since: '',
			until: '',
			since_payment: '',
			until_payment: ''
		}
	}

	toggleSidebar = () => {
	    let key: any = `leftOpen`;
	    // @ts-ignore
	    this.setState({ [key]: !this.state[key] },() => {
	    	this.props.dispatch({
	    		type: 'SET_SIDEBAR',
	    		payload: this.state.leftOpen
	    	});
	    });
	}

	checkActive = (value: string, current: string) => {
		return current.includes(value);
	}

	changeMenu = (item: MenuItem) => {
		if (item.submenu && !this.state.leftOpen) {
			this.toggleSidebar();
		}
	}

	checkPermission = (item: any) => {
		if (this.props.user?.level_id == Constants.LEVELS.ADMIN) {
			return true;
		}
		const permissions = this.props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];
		if (Array.isArray(item.permission)) {
			let _continue = false;
			item.permission.forEach((i: any) => {
				if (permissions.indexOf(i) != -1) {
					_continue = true;
				}
			});
			return _continue;
		}
		else {
			return permissions.indexOf(item.permission) != -1;
		}		
	}

	closeNavbar = () => {
		// @ts-ignore
		$('#collapsibleNavbar').collapse('hide');
	}

	toggleResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive
	  	});
	}

	closeResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive
	  	});
	}

	download = async () => {
		const res: any = await ReportService.admin.getBillingReport({
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			form: {
				...this.state.form,
				since: '',
				until: ''
			},
			modal_download: false
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	downloadPremium = async () => {
		const res: any = await ReportService.admin.getPremiumReport({
			since: this.state.form_premium.since && moment(this.state.form_premium.since).format('YYYY-MM-DD'),
			until: this.state.form_premium.until && moment(this.state.form_premium.until).format('YYYY-MM-DD'),
			since_payment: this.state.form_premium.since_payment && moment(this.state.form_premium.since_payment).format('YYYY-MM-DD'),
			until_payment: this.state.form_premium.until_payment && moment(this.state.form_premium.until_payment).format('YYYY-MM-DD'),
		});
		this.setState({
			form_premium: {
				...this.state.form_premium,
				since: '',
				until: '',
				since_payment: '',
				until_payment: ''
			},
			modal_premium: false
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	openModalDownload = () => {
		this.setState({
			modal_download: true
		});
	}

	closeModalDownload = () => {
		this.setState({
			modal_download: false
		});
	}

	openModalPremium = () => {
		this.setState({
			modal_premium: true
		});
	}

	closeModalPremium = () => {
		this.setState({
			modal_premium: false
		});
	}

	openModalCollections = () => {
		this.setState({
			modal_download_collections: true
		});
	}

	closeModalCollections = () => {
		this.setState({
			modal_download_collections: false
		});
	}

	render() {
		let leftOpen = !this.props.isAuth && this.state.leftOpen ? "open" : "closed";
		let items = [];
		const { modal_download, modal_download_collections, modal_premium } = this.state;

		if (this.props.user) {
			switch(this.props.user?.level_id) {
				case Constants.LEVELS.ADMIN:
					items = this.state.items;
				break;

				case Constants.LEVELS.MODERATOR:
					items = this.state.items;
				break;
			}
		}

		return (
			<React.Fragment>
				<Modal
		          className="modal-positions-excel"
		          visible={ modal_download }
		          title="Descargar Excel"
		          onClose={ () => this.closeModalDownload() }
		        >
		        	<div id="modal-positions-excel">
						<div className="row">
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Desde"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since'
											}
										});
									} }
									value={ this.state.form.since }
								/>
							</div>
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Hasta"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until'
											}
										});
									} }
									value={ this.state.form.until }
								/>
							</div>
						</div>
		        		<div className="text-center">
							<Button type="submit" onClick={ () => this.download() }>
								Descargar
							</Button>
						</div>
		        	</div>
		      	</Modal>

		      	<Modal
		          className="modal-positions-excel"
		          visible={ modal_premium }
		          title="Reporte de Facturación Premium"
		          onClose={ () => this.closeModalPremium() }
		        >
		        	<div id="modal-positions-excel">
						<div className="row">
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Desde"
									onChange={ (text: string) => {
										this.setState({
											form_premium: {
												...this.state.form_premium,
												since: text
											}
										});
									} }
									value={ this.state.form_premium.since }
								/>
							</div>
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Hasta"
									onChange={ (text: string) => {
										this.setState({
											form_premium: {
												...this.state.form_premium,
												until: text
											}
										});
									} }
									value={ this.state.form_premium.until }
								/>
							</div>
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Desde (Pago)"
									onChange={ (text: string) => {
										this.setState({
											form_premium: {
												...this.state.form_premium,
												since_payment: text
											}
										});
									} }
									value={ this.state.form_premium.since_payment }
								/>
							</div>
							<div className="col-md-6">
								<DatePicker
									showYearDropdown={ true }
									label="Hasta (Pago)"
									onChange={ (text: string) => {
										this.setState({
											form_premium: {
												...this.state.form_premium,
												until_payment: text
											}
										});
									} }
									value={ this.state.form_premium.until_payment }
								/>
							</div>
						</div>
		        		<div className="text-center">
							<Button type="submit" onClick={ () => this.downloadPremium() }>
								Descargar
							</Button>
						</div>
		        	</div>
		      	</Modal>

		      	<Modal
		          className="modal-download-collections"
		          visible={ modal_download_collections }
		          title="Descargar Reporte de cobranzas"
		          onClose={ () => this.closeModalCollections() }
		        >
		        	<ModalDownloadCollections />
		      	</Modal>

				{/*{
					items.length > 0 && (
						<nav className="navbar navbar-expand-lg bg-dark navbar-dark fixed-top justify-content-start">
						  <button className="navbar-toggler" type="button" onClick={ this.toggleResponsive }>
						    <img src={ MenuIcon } />
						  </button>
					    </nav>
					)
				}*/}

				<div id="left" className={ leftOpen }>
					<div className={`sidebar ${ leftOpen + ' ' + (this.state.openResponsive ? 'open-responsive' : '') }`}>
						<div className={ `shadow-close ${ this.state.openResponsive ? 'open' : '' }` } onClick={ this.closeResponsive }></div>
						<div className="container-menu">
							<div className={ `menu ${ leftOpen }` }>
								<div className="container-scroll">
									{/*<button className={ `navbar-toggler navbar-toggler-menu ${ leftOpen }` } type="button" onClick={ () => {
										this.toggleSidebar();
									} }>
									    <img src={ MenuIcon } />
									</button>
									<button className={ `navbar-toggler navbar-toggler-menu responsive ${ leftOpen }` } type="button" onClick={ () => {
										this.toggleResponsive();
									} }>
									    <img src={ MenuIcon } />
									</button>*/}
									<ul className={ leftOpen }>
										{ items.map((i: MenuItem,index: number) => {
											return (
												<React.Fragment key={ index }>
													{
														(!i.permission || this.checkPermission(i)) && (
															<li className={ `nav-item ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' }` }>
																<Link to={ i.path } className={ `${ i.submenu && i.submenu.length > 0 ? 'contain-submenu' : '' }` } onClick={ (e: any) => {
																	if (i.onClick) {
																		e.preventDefault();
																		i.onClick();
																	}
																	else {
																		if (i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) && this.props.open_menu) {
																			this.props.dispatch({
																				type: 'SET_OPEN_MENU',
																				payload: false
																			});
																			e.preventDefault();
																		}
																		else {
																			this.props.dispatch({
																				type: 'SET_OPEN_MENU',
																				payload: true
																			});
																			this.changeMenu(i);
																			this.closeResponsive();
																		}
																	}																	
																} }>
																	<div className={ `container-icon-menu ${ leftOpen } ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' }` }>
																		{
																			i.icon && (
																				<img src={ this.checkActive(i.path,this.props.history.location.pathname) ? i.iconActive : i.icon } />
																			)
																		}
																	</div>												
																	<span className={ leftOpen }>
																		<div className="container-name-menu">
																			<div className="number-menu">
																				<p>{ index + 1 }</p>
																			</div>
																			{ i.name }
																		</div>
																		{
																			i.submenu && i.submenu.length > 0 && (
																				<React.Fragment>
																					{
																						this.checkActive(i.path,this.props.history.location.pathname) ? (
																							<img className="arrow-drop" src={ this.props.open_menu ? ArrowUp : ArrowBottom } />
																						) : (
																							<img className="arrow-drop" src={ ArrowBottom } />
																						)
																					}
																				</React.Fragment>
																			)
																		}
																	</span>
																</Link>
																{
																	this.props.open_menu && (
																		<div className={ `${ i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) ? 'container-submenu' : '' }` }>
																			{
																				leftOpen != 'closed' && this.checkActive(i.path,this.props.history.location.pathname) && i.submenu && i.submenu.map((item: MenuItem,index: number) => {
																					if (!item.permission || this.checkPermission(item)) {
																						return (
																							<li className={ 'nav-item item-submenu ' + (this.props.history.location.pathname == item.path ? 'active' : '') }>
																								<Link to={ item.path } className="submenu" onClick={ (e: any) => {
																									if (item.onClick) {
																										e.preventDefault();
																										item.onClick();
																									}
																								} }>
																									{
																										item.icon && (
																											<img src={ item.icon } />
																										)
																									}
																									{ item.name }
																								</Link>
																							</li>
																						)
																					}
																				})
																			}
																		</div>
																	)
																}
															</li>
														)
													}												
												</React.Fragment>
											)
										}) }
									</ul>
								</div>
							</div>
						</div>
						<div className={ `container-router ${ leftOpen }` }>
							<Header className={ leftOpen + ' ' + (items.length > 0 && 'header-responsive') } toggleSidebar={ () => this.toggleSidebar() } toggleResponsive={ () => this.toggleResponsive() } />
							<div className={ `container-padding-router ${ items.length > 0 && 'container-responsive' }` }>{ this.props.children }</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default connect((state: any) => {
	return {
		user: state.user,
		open_menu: state.open_menu,
		sidebar: state.sidebar
	}
})(Menu);